const brand = {
	100: "#F5FCFF",
	200: "#E7F9FF",
	300: "#C9EDFF",
	400: "#0075DB",
	500: "#094C99",
	600: "#0613CF",
};

const neutrals = {
	0: "#FFFFFF",
	10: "#FAFBFC",
	15: "#F8F9FA",
	20: "#F4F5F7",
	30: "#EBECF0",
	40: "#DFE1E6",
	50: "#C1C7D0",
	60: "#B3BAC5",
	70: "#A5ADBA",
	80: "#97A0AF",
	90: "#8993A4",
	100: "#7A869A",
	200: "#6B778C",
	300: "#5E6C84",
	400: "#505F79",
	500: "#42526E",
	600: "#344563",
	700: "#253858",
	800: "#172B4D",
	900: "#051839",
};

const accent = {
	blue: {
		100: "#E9F3FF",
	},
	turquoise: {
		100: "#E3FAF8",
		200: "#95F1EB",
		300: "#0BDBCE",
		400: "#00998F",
		500: "#09736D",
	},
	green: {
		100: "#E1F5DC",
		200: "#B4EDB0",
		300: "#76DE6D",
		400: "#34A44A",
		500: "#177335",
	},
	orange: {
		100: "#FFEDD3",
		200: "#FFD79D",
		300: "#FFB240",
		400: "#DB7901",
		500: "#9E4200",
	},
	red: {
		100: "#FFE8EA",
		200: "#FFC6CB",
		300: "#F4767F",
		400: "#CC3746",
		500: "#AD1F1F",
		600: "#8e030f",
	},
	yellow: {
		100: "#FCFFD6",
		200: "#FFFFA6",
		300: "#FFF03F",
	},
	purple: {
		100: "#FAF1FF",
	},
};

const text = {
	white: neutrals[0],
	paragraph: {
		light: neutrals[200],
		regular: neutrals[500],
	},
	title: neutrals[900],
	link: {
		default: brand[500],
		hover: brand[400],
	},
};

const info = {
	background: accent.turquoise[100],
	icon: accent.turquoise[400],
	title: accent.turquoise[500],
	paragraph: text.paragraph.regular,
	link: text.link.default,
};

const success = {
	background: accent.green[100],
	icon: accent.green[400],
	title: accent.green[500],
	paragraph: text.paragraph.regular,
	plainText: accent.green[500],
	link: text.link.default,
};

const warning = {
	background: accent.orange[100],
	icon: accent.orange[400],
	title: accent.orange[500],
	paragraph: text.paragraph.regular,
	plainText: accent.orange[500],
	link: text.link.default,
};

const error = {
	background: accent.red[100],
	icon: accent.red[400],
	title: accent.red[500],
	paragraph: text.paragraph.regular,
	plainText: accent.red[500],
	link: text.link.default,
};

const form = {
	disabled: {
		background: neutrals[40],
		text: neutrals[400],
	},
	outline: {
		light: neutrals[50],
		dark: neutrals[100],
	},
};

export const colours = {
	brand,
	neutrals,
	accent,
	info,
	success,
	warning,
	error,
	form,
	text,
};
